/* This example requires Tailwind CSS v2.0+ */
import { Disclosure, Menu, Transition } from "@headlessui/react";
import { BellIcon, MenuIcon, XIcon } from "@heroicons/react/outline";
import "../assets/style.css";
import "aos/dist/aos.css"; // You can also use <link> for styles
import Aos from "aos";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

Aos.init();

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Navbar(Props) {
  let navigate = useNavigate();
console.log(Props.current === "Contact us");
  const navigation = [
    {
      name: "Home",
      href: "#",
      current: Props.current === "Home" ? true : false,
      path: "/",
    },
    { name: "About us", href: "#", current: false, path: "/" },
    {
      name: "Contact us",
      href: "#",
      current: Props.current === "Contact us" ? true : false,
      path: "/ContactUS",
    },
  ];

  const navigation1 = [
    { name: "Become a Courier", href: "#", current: true, filled: true },
  ];
  const [scrollPosition, setScrollPosition] = useState(0);
  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
    console.log(window.screen.width < 800);
    if (window.screen.width > 800) {
      if (position > 100) {
        document.getElementById("mainBar").style.backgroundColor = "#DA8B00";
        document.getElementById("currentNav").style.backgroundColor = "#0D0C34";
      } else {
        document.getElementById("mainBar").style.backgroundColor =
          "transparent";
        document.getElementById("currentNav").style.backgroundColor = "#DA8B00";

        // document.getElementById('mainBar').setAttribute('data-aos',"zoom-out")
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Disclosure as="nav" id="mainBar" className={"mainBar popupZindex"}>
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 popupZindex ">
            <div className="relative flex items-center justify-between h-20">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex-shrink-0 flex items-center">
                  <img
                    className="block lg:hidden logoimage"
                    src={require("../assets/logo.png")}
                    alt="Workflow"
                  />
                  <img
                    className="hidden lg:block logoimage"
                    src={require("../assets/logo.png")}
                    alt="Workflow"
                  />
                </div>
                <div className="hidden sm:block sm:ml-1">
                  <div className="flex space-x-2 linkstop">
                    {navigation.map((item) => (
                      <a
                        onClick={() => navigate(item.path)}
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current
                            ? " text-white font-weight-bold"
                            : "text-white font-weight-normal",
                          " px-3 py-2 rounded-md text-base font-medium mt-3"
                        )}
                        aria-current={item.current ? "page" : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
              </div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                <div className="hidden sm:block sm:ml-6">
                  <div className="flex space-x-4">
                    {navigation1.map((item) => (
                      <a
                        data-aos="fade-left"
                        data-aos-duration="800"
                        key={item.name}
                        id="currentNav"
                        href={item.href}
                        className={item.filled ? "currentNav" : "currentNav1"}
                        aria-current={item.current ? "page" : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                  </div>
                </div>
                {/* Profile dropdown */}
                {/* <Menu as="div" className="ml-3 relative popupZindex">
                  <div>
                    <Menu.Button
                     data-aos="fade-left"
                     data-aos-duration="1200"
                      className="bg-gray-800 flex text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                      <span className="sr-only">Open user menu</span>
                      <img
                        className="h-8 w-8 rounded-full"
                        src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                        alt=""
                      />
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            className={classNames(
                              active ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            Your Profile
                          </a>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            className={classNames(
                              active ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            Settings
                          </a>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <a
                            href="#"
                            className={classNames(
                              active ? "bg-gray-100" : "",
                              "block px-4 py-2 text-sm text-gray-700"
                            )}
                          >
                            Sign out
                          </a>
                        )}
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu> */}
              </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1">
              <div className="flex space-x-4">
                {navigation1.map((item) => (
                  <Disclosure.Button
                    key={item.name}
                    as="a"
                    href={item.href}
                    className={item.filled ? "currentNav" : "currentNav1"}
                    aria-current={item.current ? "page" : undefined}
                  >
                    {item.name}
                  </Disclosure.Button>
                ))}
              </div>

              {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current
                      ? "bg-gray-900 text-white"
                      : "text-gray-300 hover:bg-gray-700 hover:text-white",
                    "block px-3 py-2 rounded-md text-base font-medium"
                  )}
                  aria-current={item.current ? "page" : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  );
}
